import moment from 'moment';

export function SummaryController(
    $animateCss,
    $document,
    $scope,
    $state,
    $q,
    INVALID_DATE_ERROR,
    OUT_OF_STOCK_ERROR,
    availabilitiesFactory,
    browserDetectService,
    calloutService,
    cartDisplayService,
    cartService,
    cartStatusChannel,
    googleAnalyticsTrackingService,
    itemStatusChannel,
    loyaltyService,
    promoCodeService,
    restaurantInfoFactory
) {
    'ngInject';

    $scope.cancelChanges = cancelChanges;
    $scope.hasWarnings = cartService.hasWarnings;
    $scope.getWarningsString = cartDisplayService.getWarningsString;
    $scope.cartDisplay = {};
    $scope.flags = {
        browserFlags: browserDetectService().indexOf('Mobile') === -1, // if we ever want to disable based on browser
        restaurantAvailable: true
    };
    $scope.dateFlags = {
        hasError: false
    };

    $scope.removeItemEvent = googleAnalyticsTrackingService.getRemoveItemEvent();
    $scope.startUpdateItemEvent = googleAnalyticsTrackingService.getStartUpdateItemEvent();
    $scope.startEditDetailsOnDiningOptionPreviewEvent = googleAnalyticsTrackingService.getStartEditDetailsOnDiningOptionPreviewEvent();
    $scope.startEditDetailsOnDateTimePreviewEvent = googleAnalyticsTrackingService.getStartEditDetailsOnDateTimePreviewEvent();
    $scope.startEditDetailsOnEditDetailButtonEvent = googleAnalyticsTrackingService.getStartEditDetailsOnEditDetailButtonEvent();

    activate();

    function cancelChanges() {
        cartDisplayService.rollback().then(() => {
            if ($scope.summaryFlags.edit === true) {
                $scope.toggleSummaryEdit();
            }
        });
    }

    $scope.toggleSummaryEdit = function() {
        cartDisplayService.setDiningServiceSelected(!cartDisplayService.getDiningServiceSelected());
        if ($scope.cartDisplay.enableOO) {
            $scope.summaryFlags.edit = !$scope.summaryFlags.edit;
            moment.parseZone($scope.curCart.fulfillmentDateTime);
        }
    };

    $scope.displayError = function(flag, data) {
        flag.hasError = true;

        if (data instanceof Error) {
            $scope.errorMessage = data.message;
            // Uncomment for a nice stack trace if you need to debug an error.
            // console.error(data);
        }

        if (data && data.errorMessage) {
            $scope.errorMessage = data.errorMessage;
            $scope.cartFlags.errorType = data.error;
        }
        switch (data.error) {
        case OUT_OF_STOCK_ERROR:
            cartStatusChannel.changedCart();
            break;
        case INVALID_DATE_ERROR:
            // To allow change of dining option, even if one triggers the invalid order date
            $scope.cartFlags.loading = false;
            $scope.summaryFlags.loading = false;
            $scope.cartFlags.hasError = false;
            break;
        default:
        }
    };

    $scope.hideChoices = function() {
        cartDisplayService.setDiningServiceSelected(true);
        googleAnalyticsTrackingService.trackFinishEditDetailsEvent();

        if (!moment.isMoment(cartDisplayService.displayData.fulfillmentMoment)) {
            var error = calloutService.error('Invalid Date');
            $scope.displayError($scope.dateFlags, error);
            return;
        }

        $scope.configureCart(
            $scope.cartDisplay.diningOption,
            $scope.cartDisplay.fulfillmentType,
            $scope.cartDisplay.fulfillmentMoment
        );
    };

    $scope.summaryFlags = {
        // Whether the cart edit pane should show
        edit: false,
        // Whether the cart is being updated on the server
        loading: false
    };

    $scope.cartFlags = {
        // Whether the cart is being loaded from the server
        loading: true,
        // Whether there is an error to be displayed on the cart
        hasError: false
    };

    // Reference to the cart in cart service, used to display the cart on the right panel
    $scope.curCart = null;

    /**
         * removeItem(): deletes the given item on the front-end and back-end
         *  -> Only one delete can happen at a time.
         */
    $scope.removeItem = function(cartItem, $event) {
        if (!$scope.cartFlags.loading) {
            $scope.cartFlags.loading = true;

            googleAnalyticsTrackingService.trackECRemoveCartItem(cartItem);

            cartService.removeCartItem(cartItem)
                .then(() => {
                    cartDisplayService.updateFulfillmentTimeFromCart();
                    cartStatusChannel.changedCart();

                    $animateCss(angular.element($document[0].querySelector('.t-badge')), {
                        keyframeStyle: 'badge .4s'
                    }).start();
                });
        }
        if ($event.stopPropagation) $event.stopPropagation();
    };

    $scope.removePromoCode = promoCodeService.removePromoCode;

    $scope.removeLoyaltyRedemption = function(redemptionGuid) {
        loyaltyService.removeLoyaltyRedemption({
            redemptionGuid: redemptionGuid,
            skipCallout: true
        }).then(
            resp => removeLoyaltyRedemptionSuccess(resp.data),
            error => removeLoyaltyRedemptionError(error)
        );
    };

    function removeLoyaltyRedemptionSuccess(resp) {
        googleAnalyticsTrackingService.trackLoyaltyRedemption('remove', true);

        cartService.setCart(resp);
        cartStatusChannel.changedCart();
    }

    function removeLoyaltyRedemptionError() {
        googleAnalyticsTrackingService.trackLoyaltyRedemption('remove', false);

        calloutService.error('There was an issue removing your reward, please try again');
    }

    /**
         * updateCart(): Updates the cart on the server, then on the front-end
         */
    $scope.updateCart = function() {
        $scope.cartFlags.loading = true;

        return cartService.updateCart({
            tipAmount: null,
            paymentMethod: null,
            skipCallout: true,
            deliveryInfo: null
        }).then(function() {
            $scope.curCart = cartService.data.cart;
            $scope.cartFlags.loading = false;
            hideError();
        }).catch(function(error) {
            $scope.displayError($scope.cartFlags, error);
            $scope.cartFlags.loading = false;
        });
    };

    function hideError() {
        if($scope.cartFlags.errorType !== OUT_OF_STOCK_ERROR) {
            $scope.cartFlags.hasError = false;
            $scope.cartFlags.errorType = null;
        }
    }

    $scope.configureCart = function(diningOptionBehavior, fulfillmentType, fulfillmentDate) {
        $scope.cartFlags.loading = true;
        $scope.summaryFlags.loading = true;

        cartService.configureCart(diningOptionBehavior, fulfillmentType, fulfillmentDate, false)
            .then(function() {
                // Update cart on client side to fix totals and subtotals to accommodate service fees
                //clear cart to get updated version with new applied service charges from server
                $scope.summaryFlags.edit = false;
                cartService.clearCart();
                return cartService.getCart();
            }).then(function(cart) {
                $scope.curCart = cart;
                $scope.cartFlags.loading = false;
                $scope.summaryFlags.loading = false;
                $scope.cartFlags.hasError = false;
                cartDisplayService.updateFulfillmentTimeFromCart();

            }).catch(function(error) {
                $scope.displayError($scope.cartFlags, error);
                $scope.cartFlags.loading = false;
                $scope.summaryFlags.loading = false;

                if (!$scope.cartDisplay.restaurantAvailable) {
                    $scope.summaryFlags.edit = false;
                    return;
                }
            });
    };

    $scope.checkoutCart = function() {

        cartService.configureCart($scope.cartDisplay.diningOption,
            $scope.cartDisplay.fulfillmentType,
            $scope.cartDisplay.fulfillmentMoment, true)
            .then(function() {
                cartDisplayService.updateFulfillmentTimeFromCart();
                $state.go('checkout');
                cartService.clearCartError();
            })
            .catch(function(error) {
                $scope.displayError($scope.cartFlags, error);
            });
    };

    /**
         * editItem(): broadcasts an event to child controllers
         *  -> Signals the child controller (modifierDialogController) to display the modifiers dialog to edit the item
         *  -> Makes a working copy of the cartItem to edit, this way you can't edit the cartItem to an invalid state
         */
    $scope.editItem = function(cartItem) {
        itemStatusChannel.editItem(cartItem);
    };

    function activate() {
        cartDisplayService
            .getDisplayData()
            .finally(() => {
                _setCartDisplayData();
                _getRestaurantInfo();
            });
    }

    function _setCartDisplayData() {
        $scope.cartDisplay = cartDisplayService.displayData;

        let fulfillmentMoment = $scope.cartDisplay.fulfillmentMoment,
            fulfillmentDateStr = fulfillmentMoment ? fulfillmentMoment.format() : null;

        cartStatusChannel.configuredCart(fulfillmentDateStr);
    }

    function _getRestaurantInfo() {
        var infoPromise = restaurantInfoFactory.getInfo(['general']).then(setTimeZone);
        var cartPromise = cartService.getCart().then(setupCartData);

        $q.all([infoPromise, cartPromise]).catch(function(response) {
            $scope.displayError($scope.cartFlags, response);
        });
    }

    function setTimeZone(info) {
        availabilitiesFactory.setTimeZone(info.general.timeZone);
    }

    function setupCartData(cart) {
        $scope.cartData = cartService.getCartData();
        $scope.curCart = cart;
        $scope.cartFlags.loading = false;
    }

    // Update cart when item is added to it
    cartStatusChannel.onChangedCart($scope, $scope.updateCart);

    cartStatusChannel.onEditedCart($scope, $scope.configureCart);

    if (cartService.getCartData().error) {
        $scope.displayError($scope.cartFlags, cartService.getCartData().error);
    }

    $scope.$on('$destroy', cancelChanges);
}
